import { EditNoteOutlined } from "@mui/icons-material";
import Button from "@mui/material/Button";
import { memo, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loanDrilldownSidebarTypes } from "../../../../constants/enums/loanDrilldownScreenSidebarOptions";
import {
  sidebarSetStateValue,
  sidebarTypeSet,
} from "../../../../redux/actions/sidebarActions";
// import LoanExceptionsTable from "./LoanExceptionsTable";
import { Box, Divider } from "@mui/material";
import PrimaryContentCard from "../../../../_src_shared/components/layout/PrimaryContentCard";
import LoanExceptionsTable from "../../../../components/common/Loan/tables/LoanExceptionsTable";

const LoanDrilldownExceptionsTab = ({ value, tab }) => {
  const [quickFilter, setQuickFilter] = useState(null);
  const loanExceptions = useSelector(
    (state) => state?.loanDrilldown?.exceptions || [],
  );
  const dispatch = useDispatch();

  const handleOnRowClicked = useCallback((d) => {
    dispatch(sidebarTypeSet(loanDrilldownSidebarTypes.ADD_EXCEPTION));
    dispatch(sidebarSetStateValue(d));
  }, []);

  return (
    <Box sx={{ p: 4 }}>
      <PrimaryContentCard
        maxWidth={false}
        title="Loan Exceptions"
        endContent={<AddExceptionButton />}
      >
        <Divider sx={{ mt: 0.5, mb: 4, borderWidth: "1.5px" }} />
        <LoanExceptionsTable
          rowData={loanExceptions}
          onRowClicked={handleOnRowClicked}
          quickFilterText={quickFilter}
        />
      </PrimaryContentCard>
    </Box>
  );
};
const AddExceptionButton = memo(() => {
  const dispatch = useDispatch();

  const handleToggle = () => {
    dispatch(sidebarTypeSet(loanDrilldownSidebarTypes.ADD_EXCEPTION));
    dispatch(sidebarSetStateValue(null));
  };

  return (
    <Button
      sx={{ ml: 1 }}
      startIcon={<EditNoteOutlined />}
      onClick={handleToggle}
    >
      Add Exception
    </Button>
  );
});
export default LoanDrilldownExceptionsTab;
